import React from 'react';
import { PersonDetail } from '../../../types/personDetail';
import { InitialsAvatar, EntityOverview, StatusTag, InfoColumn } from '../../shared';

interface PersonOverviewProps {
  personDetail: PersonDetail;
  infoColumns?: InfoColumn[];
}

export const PersonOverview: React.FC<PersonOverviewProps> = ({ personDetail, infoColumns }) => {
  const fullName = `${personDetail.firstName} ${personDetail.lastName}`;
  
  // Build subtitle with email and phone
  const contactInfo = [
    personDetail.email,
    personDetail.phoneNumber,
  ].filter(Boolean).join(' • ');
  
  return (
    <EntityOverview
      avatar={personDetail.avatarUrl ? undefined : <InitialsAvatar name={fullName} size={80} />}
      avatarUrl={personDetail.avatarUrl}
      avatarAlt={fullName}
      title={fullName}
      tags={personDetail.familyPosition && <StatusTag label={personDetail.familyPosition} variant="info" />}
      subtitle={contactInfo || 'No contact information'}
      description={personDetail.address}
      infoColumns={infoColumns}
      className="mb-6"
    />
  );
};
